import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import { formatTeamsData } from "./ChartBuilder/teamFilterComponents";
import { props } from "bluebird";

const TeamFilterHierarchyPlaceHolder = ({
  label,
  value,
  variant,
  onChange,
  name,
  options,
  disabled,
  labelColorCondition,
  renderValue,
  getOptionLabel,
  getOptionValue,
  data,
  onTeamChange,
  showAllOption = false, // New prop to control "All" option visibility
}) => {
  // Process data based on showAllOption
  let filteredData = data;
  let hasAllInData = false;

  if (data && data.length > 0 && data[0].Parent === "All") {
    hasAllInData = true;
    if (!showAllOption) {
      // If showAllOption is false, remove "All" by extracting its children
      filteredData = data[0].teams || [];
    }
  }

  const teamsList = formatTeamsData(filteredData);
  console.log('TeamFilterHierarchyPlaceHolder - showAllOption:', showAllOption);
  console.log('TeamFilterHierarchyPlaceHolder - hasAllInData:', hasAllInData);
  console.log('TeamFilterHierarchyPlaceHolder - original data:', data);
  console.log('TeamFilterHierarchyPlaceHolder - filtered data:', filteredData);

  const handleChange = (e) => {
    // Get the selected value (single selection)
    const selectedValue = e.target.value;
    console.log("Selected Team:", selectedValue);

    // Pass the single selected value to the parent component (not as array)
    onTeamChange(selectedValue);

    /* COMMENTED OUT - MULTI-SELECT LOGIC
    // Get the selected values from the event (multi-select dropdown)
    let selectedValues = [...e.target.value]; // Copy selected values into an array
    console.log("step1:selectedValues", selectedValues);

    let lastSelected = selectedValues[selectedValues.length - 1]; // Get the most recently selected value
    console.log("step2:lastSelected", lastSelected);

    let teamRawData = data; // Assume `data` contains hierarchical team structure
    console.log("step3:teamRawData", teamRawData);

    const updatedSelectedValues = new Set(selectedValues); // Use Set to store unique selected values
    console.log("step4:updatedSelectedValues");

    // Function to remove all child elements when a parent is selected
    const deselectChildren = (parent, teams) => {
      teams.forEach((team) => {
        if (team.Parent === parent) {
          // If the current team is a child of the selected parent, remove it
          team.teams.forEach((child) => {
            updatedSelectedValues.delete(child.Parent); // Remove child from selection
            deselectChildren(child.Parent, teams); // Recursively remove all deeper children
          });
        } else if (team.teams.length > 0) {
          // If the current team has sub-teams, check them as well
          deselectChildren(parent, team.teams);
        }
      });
    };

    // Function to remove all parent elements when a child is selected
    const deselectParents = (child, teams) => {
      for (const team of teams) {
        // Check if the current team has this child in its sub-teams
        if (team.teams.some((subTeam) => subTeam.Parent === child)) {
          updatedSelectedValues.delete(team.Parent); // Remove parent from selection
          deselectParents(team.Parent, teamRawData); // Recursively remove all higher-level parents
        }
        // Continue checking deeper levels
        deselectParents(child, team.teams);
      }
    };

    if (lastSelected) {
      // If a parent is selected, remove all its children to prevent conflicts
      console.log("step5:lastSelected_deselectChildren", lastSelected);

      deselectChildren(lastSelected, teamRawData);

      console.log("step6:lastSelected_deselectParents", lastSelected);

      // If a child is selected, remove all its parent elements up to the root
      deselectParents(lastSelected, teamRawData);
    }

    // Convert the Set back to an array and pass the updated selection to the parent component
    console.log("Updated Selected Values:", Array.from(updatedSelectedValues));
    onTeamChange(Array.from(updatedSelectedValues));
    */
  };

  // Don't render the component if there's no data
  if (!teamsList || teamsList.length === 0) {
    return null;
  }

  return (
    <FormControl fullWidth disabled={disabled}>
      {variant === undefined && (
        <InputLabel
          shrink
          style={{
            color: labelColorCondition ? "#4472c4" : "#000",
          }}
          id={`${name}-label`}
        >
          {label}
        </InputLabel>
      )}
      <Select 
        variant={variant}
        value={Array.isArray(value) ? (value.length > 0 ? value[0] : "") : value} // MODIFIED - Convert array to first element or empty string
        onChange={handleChange}
        name={name}
        // multiple  {/* COMMENTED OUT - For single select */}
        renderValue={(selected) => {
          if (!selected || selected === "") { // MODIFIED - simplified check
            return <span style={{ color: "#aaa" }}>Please select team</span>;
          }
          return renderValue ? renderValue(selected) /* .join(", ") */ : selected /* .join(", ") */; // MODIFIED - removed join for single value
        }}
        displayEmpty
      >
        {/* Only add "All" MenuItem if showAllOption is true AND "All" is not already in the data */}
        {showAllOption && !hasAllInData && <MenuItem value={"All"}>All</MenuItem>}
        {teamsList.map((option) => {
          return (
            <MenuItem
              key={getOptionValue(option)}
              value={option.label}
              style={{
                marginLeft: `${option.indent * 1}rem`,
              }}
            >
              {`${getOptionLabel(option)}`}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default TeamFilterHierarchyPlaceHolder;